<template>
  <div
    v-bind="$attrs"
    class="fixed bottom-0 right-0 z-40 flex max-h-[calc(100vh-6.25rem-var(--sat))] max-w-full flex-col items-end p-2 pointer-events-none transition-all duration-700"
    :class="
      props.visible
        ? 'translate-y-0 opacity-100'
        : 'translate-y-full opacity-0 invisible'
    "
  >
    <div
      class="bottom-full right-0 pr-2"
      :class="props.visible ? 'absolute' : 'hidden'"
    >
      <button
        type="button"
        aria-label="Close floating banners"
        class="rounded-full text-gray-600 bg-white/50 p-1.5 pointer-events-auto hover:bg-white/90 hover:text-gray-800 transition-all"
        @click="emit('close')"
      >
        <BaseIcon name="outline_x" />
      </button>
    </div>

    <div class="-m-6 min-h-0 min-w-0 overflow-y-auto">
      <div class="flex flex-col items-end min-w-0 max-w-full gap-2 p-6">
        <div
          v-for="banner in props.banners"
          :key="banner.key"
          class="min-w-0 max-w-full pointer-events-auto"
          :style="{ width: `${banner.formData.width}px` }"
        >
          <FloatingBannerContent
            :form-data="banner.formData"
            :items="banner.items"
            @item-click="onItemClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FloatingBannerContent from './FloatingBannerContent.vue'
import type { FloatingBannerItem, FloatingBannerRuntimeBanner } from './types'

defineOptions({ inheritAttrs: false })

interface PropsInterface {
  banners: FloatingBannerRuntimeBanner[]
  visible: boolean
}

const props = defineProps<PropsInterface>()
const emit = defineEmits<{
  close: []
  'item-click': [item: FloatingBannerItem, event: MouseEvent]
}>()

function onItemClick(item: FloatingBannerItem, event: MouseEvent) {
  emit('item-click', item, event)
}
</script>
